import { formatNumber } from 'utils/formatting';
import * as S from './DashboardStats.styled';

type Stat = {
    label: string;
    value: number;
    change?: string;
    currency?: string;
};

interface DashboardStatsProps {
    stats: Stat[];
}

export default function DashboardStats({ stats }: DashboardStatsProps) {
    return (
        <S.StatsContainer>
            {stats.map((stat, index) => (
                <S.StatItem key={index}>
                    <S.Header>
                        <S.Label>{stat.label}</S.Label>
                        {stat.change && <S.ChangeIndicator>↑ {stat.change}</S.ChangeIndicator>}
                    </S.Header>

                    <S.Value>
                        {stat.currency}
                        {formatNumber(stat.value)}
                    </S.Value>
                </S.StatItem>
            ))}
        </S.StatsContainer>
    );
}
